import Select from 'react-select';
import styled from 'styled-components';

import FlexWrap from '@/components/common/FlexWrap';
import { useGetForeignCurrencyHistory } from '@/hooks/useGetForeignCurrencyHistory';

function FXReceiptViewSelector() {
  const { size, setSizeAndResetPage } = useGetForeignCurrencyHistory();

  const options = [
    { label: '10개씩 보기', value: 10 },
    { label: '100개씩 보기', value: 100 },
    { label: '500개씩 보기', value: 500 },
  ];

  const selectedOption = options.find((option) => option.value === size) || options[0];

  const onChange = (e: any) => {
    setSizeAndResetPage(e.value);
  };
  return (
    <ViewContainer>
      <Select
        isSearchable={false}
        //@ts-ignore
        value={selectedOption}
        onChange={onChange}
        //@ts-ignore
        options={options}
        styles={{
          container: (baseStyles: any) => ({
            ...baseStyles,
            marginLeft: 'auto',
            padding: 3,
            backgroundColor: 'transparent',
            border: '1.5px solid #CBCCCE',
            borderRadius: 4,
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            height: '36px',
            width: '212px',
          }),
          control: () => ({
            display: 'flex',
            alignItems: 'center',
            height: 22,
            width: 170,
          }),
          indicatorSeparator: () => ({
            width: 0,
          }),
          singleValue: (baseStyles: any) => ({
            ...baseStyles,
            color: '#80848A',
            fontFamily: 'Pretendard, sans-serif',
            fontWeight: '500',
          }),
        }}
      />
    </ViewContainer>
  );
}

const ViewContainer = styled(FlexWrap)`
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
`;

export default FXReceiptViewSelector;
